import { render, staticRenderFns } from "./SupplierGroupDisplayView.vue?vue&type=template&id=c9213966"
import script from "./SupplierGroupDisplayView.vue?vue&type=script&lang=js"
export * from "./SupplierGroupDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports